import React, { useState } from 'react';
import {
  Dialog,
  DialogSurface,
  DialogBody,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Input,
} from '@fluentui/react-components';
import { DismissRegular } from '@fluentui/react-icons';

interface PasswordDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  user: any;
  presetPassword: string;
}

const PasswordDialog: React.FC<PasswordDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  user,
  presetPassword,
}) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleConfirm = () => {
    if (password === presetPassword) {
      onConfirm();
      setPassword('');
      setError('');
    } else {
      setError('Felaktigt lösenord');
    }
  };

  const handleClose = () => {
    setPassword('');
    setError('');
    onClose();
  };

  return (
    <Dialog modalType='alert' open={isOpen} onOpenChange={(_, data) => !data.open && handleClose()}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle
            action={
              <Button
                appearance="subtle"
                icon={<DismissRegular />}
                onClick={handleClose}
              />
            }
          >
            {title}
          </DialogTitle>
          <DialogContent>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-2">Lösenord</label>
                <Input
                  type="password"
                  className="w-full"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && handleConfirm()}
                  autoFocus
                />
                {error && <p className="text-red-600 text-sm mt-2">{error}</p>}
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button appearance="secondary" onClick={handleClose}>
              Avbryt
            </Button>
            <Button appearance="primary" onClick={handleConfirm} disabled={!password.trim()}>
              Bekräfta
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default PasswordDialog;
